import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Dices, CandlestickChart, ScrollText, ArrowRight } from "lucide-react";
import { LOBBY_ART } from "@/lib/casinoArt";

const TILES = [
  { to: "/arcade", key: "arcade", title: "The Arcade", sub: "6 live games · real Deriv contracts", badge: "HOT", icon: Dices, big: true },
  { to: "/charts", key: "charts", title: "Trading Floor", sub: "Live candles · Rise / Fall", badge: "LIVE", icon: CandlestickChart },
  { to: "/history", key: "history", title: "The Vault", sub: "Every round, every payout", badge: "LOG", icon: ScrollText },
];

export const LobbyTiles = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-4 sm:gap-5" data-testid="lobby-tiles">
    {TILES.map((t, i) => (
      <motion.div
        key={t.key}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.08 * i, duration: 0.5 }}
        className={t.big ? "md:col-span-2 md:row-span-2" : ""}
      >
        <Link
          to={t.to}
          data-testid={`lobby-tile-${t.key}`}
          className={`casino-tile group relative block overflow-hidden rounded-2xl ${t.big ? "h-64 sm:h-80 md:h-full md:min-h-[420px]" : "h-48 sm:h-[200px]"}`}
        >
          <img src={LOBBY_ART[t.key]} alt={t.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
          <span className="absolute top-4 left-4 marquee-badge">{t.badge}</span>
          <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6 flex items-end justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 text-gold">
                <t.icon className="h-5 w-5" />
                <span className="text-[10px] uppercase tracking-[0.3em] text-gold/80">Enter</span>
              </div>
              <div className={`font-casino text-gold-grad mt-1 ${t.big ? "text-3xl sm:text-5xl" : "text-2xl sm:text-3xl"}`}>{t.title}</div>
              <div className="text-sm text-white/70 mt-1">{t.sub}</div>
            </div>
            <div className="h-11 w-11 shrink-0 rounded-full btn-gold flex items-center justify-center transition-transform group-hover:translate-x-1">
              <ArrowRight className="h-5 w-5" />
            </div>
          </div>
        </Link>
      </motion.div>
    ))}
  </div>
);
